export enum ETransactionStatus {
  Detected = 'Detected',
  Rejected = 'Rejected',
  Completed = 'Completed',
}
